export const idleSubmitting = () => ({
  status: 'idle',
  method: null,
})

export const pendingEmailSubmitting = () => ({
  status: 'pending',
  method: 'email',
})

export const pendingFacebookSubmitting = () => ({
  status: 'pending',
  method: 'facebook',
})

export const toLegacySubmitting = (submittingState) => {
  if (!submittingState || submittingState.status !== 'pending') {
    return false
  }

  if (submittingState.method === 'email') return 'email-loading'
  if (submittingState.method === 'facebook') return 'facebook-loading'

  return true
}

export const isSubmitting = (submittingState) =>
  submittingState?.status === 'pending'
